import configuration from "../../utilities/configuration";
import UseCaseCategoryModel from "../../models/useCase/UseCaseCategoryModel";
import UseCaseModel from "../../models/useCase/UseCaseModel";
import * as EffectUtility from "../../utilities/EffectUtility";
import { BaseModel } from "sjs-base-model";

export async function requestAllCategories() {
    const endpoint = configuration.apiServer + configuration.apiUseCaseCategoriesPath;
    return EffectUtility.getToModel(UseCaseCategoryModel, endpoint);
}

export async function addCategory(category) {
    const endpoint = configuration.apiServer + configuration.apiUseCaseCategoriesPath;
    return EffectUtility.postToModel(BaseModel, endpoint, category);
}

export async function updateCategory(id, category) {
    const endpoint = configuration.apiServer + configuration.apiUseCaseCategoriesPath + "/" + id;
    return EffectUtility.putToModel(BaseModel, endpoint, category);
}

export async function deleteCategory(id) {
    const endpoint = configuration.apiServer + configuration.apiUseCaseCategoriesPath + "/" + id;
    return EffectUtility.deleteToModel(BaseModel, endpoint)
}

export async function requestAllUseCases() {
    const endpoint = configuration.apiServer + configuration.apiUseCasesPath;
    return EffectUtility.getToModel(UseCaseModel, endpoint);
}

export async function addUseCase(useCase) {
    const endpoint = configuration.apiServer + configuration.apiUseCasesPath;
    return EffectUtility.postToModel(BaseModel, endpoint, useCase);
}

export async function updateUseCase(id, category) {
    const endpoint = configuration.apiServer + configuration.apiUseCasesPath + "/" + id;
    return EffectUtility.putToModel(BaseModel, endpoint, category);
}

export async function deleteUseCase(id) {
    const endpoint = configuration.apiServer + configuration.apiUseCasesPath + "/" + id;
    return EffectUtility.deleteToModel(BaseModel, endpoint)
}